import { render, staticRenderFns } from "./SupportBottomMenu.vue?vue&type=template&id=22114a51&scoped=true"
import script from "./SupportBottomMenu.vue?vue&type=script&lang=js"
export * from "./SupportBottomMenu.vue?vue&type=script&lang=js"
import style0 from "./SupportBottomMenu.vue?vue&type=style&index=0&id=22114a51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22114a51",
  null
  
)

export default component.exports